import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

/**
 * MDB Button Directive
 *
 * Applies MDB5 button styling to elements.
 *
 * Usage:
 * ```html
 * <button mdbButton color="primary">Click me</button>
 * <button mdbButton color="secondary" outline>Outline</button>
 * <button mdbButton color="success" size="lg">Large</button>
 * ```
 */
@Directive({
  selector: '[mdbButton]',
  standalone: false,
})
export class MdbButtonDirective implements OnInit {
  @Input() color: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link' = 'primary';
  @Input() outline = false;
  @Input() size: 'sm' | 'lg' | '' = '';
  @Input() block = false;
  @Input() floating = false;
  @Input() rounded = false;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.applyButtonClasses();
  }

  private applyButtonClasses(): void {
    const element = this.elementRef.nativeElement;

    // Base button class
    this.renderer.addClass(element, 'btn');

    // Color class
    if (this.outline) {
      this.renderer.addClass(element, `btn-outline-${this.color}`);
    } else if (this.floating) {
      this.renderer.addClass(element, `btn-floating`);
      this.renderer.addClass(element, `btn-${this.color}`);
    } else {
      this.renderer.addClass(element, `btn-${this.color}`);
    }

    // Size class
    if (this.size) {
      this.renderer.addClass(element, `btn-${this.size}`);
    }

    // Block class
    if (this.block) {
      this.renderer.addClass(element, 'btn-block');
    }

    // Rounded class
    if (this.rounded) {
      this.renderer.addClass(element, 'btn-rounded');
    }
  }
}
